export const toCamelCase = (jsonTag: string) => {
  const newTag = jsonTag
    .split(".")
    .map((section) => `${section[0].toUpperCase()}${section.slice(1)}`)
    .join("");
  const firstLetter = newTag[0].toLowerCase();
  return `${firstLetter}${newTag.slice(1)}`;
};
